// Allows +, digits; no spaces. Enforces at least 10 digit characters (supports country codes, e.g. +9779812345678, +44987654321).
export function phoneValidate(yup) {
    return yup
        .string()
        .typeError('Not a valid number')
        .test('phone-with-country-code', 'Enter a valid number with country code (e.g. +9779812345678 or +44987654321)', function (v) {
            if (!v || typeof v !== 'string') return false;
            const digits = (v || '').replace(/\D/g, '');
            return digits.length >= 10;
        });
}

// Optional phone: valid if empty, or must have 10+ digits if provided.
export function phoneValidateOptional(yup) {
    return yup
        .string()
        .nullable()
        .transform((v) => (v && typeof v === 'string' ? v.trim() : null) || null)
        .test('phone-optional', 'Enter a valid number with country code (e.g. +9779812345678)', function (v) {
            if (!v || v === '') return true;
            const digits = String(v).replace(/\D/g, '');
            return digits.length >= 10;
        });
}

export function textValidate(yup) {
    return yup
        .string()
        .typeError('Not a valid text')
        .matches(/^[A-Za-z ]+$/, 'Please enter a valid text');
}

export function alphaNumericValidate(yup) {
    return yup
        .string()
        .typeError('Not a valid number pr text')
        .matches(/^[ A-Za-z0-9_@.]*$/, 'Please enter a valid text or number');
}

export function numberValidate(yup) {
    return yup
        .string()
        .typeError('Not a valid number')
        .matches(new RegExp("^\\d+$"), 'Please enter a valid number');
}